module.exports = __webpack_public_path__ + "img/sir_no.c7eea36e.png";